
    customElements.whenDefined('sp-tag').then(() => {
        const deletable = document.querySelectorAll('sp-tag[deletable]');
        deletable.forEach(tag => {
            tag.addEventListener('delete', () => {
                spAlert(tag, 'Tag item deleted.');
            })
        });
    });
